import { HTMLProps, memo, useCallback, useState } from 'react';
import cx from 'classnames';

import { OnStageUser } from 'types';
import { choosePaletteColor, getFirstLetters } from 'utils';
import { Color, Text } from 'components';

import styles from './Speaker.Image.module.scss';

export type SpeakerImageProps = {
  seatIndex?: number;
} & Pick<HTMLProps<HTMLDivElement>, 'className'> &
  Partial<Pick<OnStageUser, 'name' | 'image'>> & {};

const SpeakerImage = ({ className, name, image, seatIndex }: SpeakerImageProps) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  const initials = name && getFirstLetters(name.trim().split(' ').slice(0, 2));
  const color = choosePaletteColor(initials, seatIndex);

  const handleOnImageLoadError = useCallback(() => setImageLoadError(true), []);

  return (
    <div className={cx(styles.container, className)}>
      {image && !imageLoadError ? (
        <img src={image} alt="speaker" onError={handleOnImageLoadError} />
      ) : (
        <Color color={color} className={styles.placeholder}>
          {name && (
            <Text color="white" size="h2" weight="bold">
              {initials}
            </Text>
          )}
        </Color>
      )}
    </div>
  );
};

const MemoizedSpeakerImage = memo(SpeakerImage);

export default MemoizedSpeakerImage;
